app.service('regulations', function (loading, modal, front) {
	var idModal = 'regulations';
	var savedContent = false;

	function show() {
		loading.start();
		setTimeout(function () {		// do sprawdzenia działania INP z CoreVitals
			if (savedContent) {
				modal.open(idModal);
			} else {
				load();
			}
		}, 1);
	}

	function loadSuccess() {
		loading.stop();
		modal.generate({
			header: front.isRwd() ? false : 'Regulamin Serwisu',
			content: front.isRwd() ? '<div class="content">' + savedContent + '</div>' : savedContent,
			id: idModal,
			modifier: front.isRwd() ? 'remodal-full-width' : ''
		});
	}
	function loadError() {
		loading.stop();
		modal.alert('Błąd ładowania regulaminu');
	}
	function load() {
		loading.start();
		$.ajax({
			url: '/front-message.ltr',
			data: {
				code: 'regulamin',
				onlyText: true
			},
			success: function (htmlContent) {
				savedContent = htmlContent
				loadSuccess();
			},
			error: function () {
				loadError();
			}
		});
	}

	return {
		show: show
	};
});
